var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87868 11.1213C10.4413 11.6839 11.2044 12 12 12C12.394 12 12.7841 11.9224 13.1481 11.7716C13.512 11.6209 13.8427 11.3999 14.1213 11.1213C14.3999 10.8427 14.6209 10.512 14.7716 10.1481C14.9224 9.78407 15 9.39397 15 9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7956 6 12 6C11.2044 6 10.4413 6.31607 9.87868 6.87868C9.31607 7.44129 9 8.20435 9 9C9 9.79565 9.31607 10.5587 9.87868 11.1213ZM12 21.2395C11.8179 21.0266 11.5768 20.7397 11.2945 20.3919C10.6447 19.5913 9.77908 18.4706 8.91448 17.1891C8.04892 15.9062 7.19053 14.4713 6.55005 13.0417C5.90664 11.6055 5.5 10.2113 5.5 9C5.5 7.27609 6.18482 5.62279 7.40381 4.40381C8.62279 3.18482 10.2761 2.5 12 2.5C13.7239 2.5 15.3772 3.18482 16.5962 4.40381C17.8152 5.62279 18.5 7.27609 18.5 9C18.5 10.2113 18.0934 11.6055 17.4499 13.0417C16.8095 14.4713 15.9511 15.9062 15.0855 17.1891C14.2209 18.4706 13.3553 19.5913 12.7055 20.3919C12.4232 20.7397 12.1821 21.0266 12 21.2395Z",
    stroke: "#170E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLight);
export default __webpack_public_path__ + "static/media/mdi-light.ad2e96ea578368763373980b73611aeb.svg";
export { ForwardRef as ReactComponent };